import { createDefaultTyrann } from '@apis/common';
import {
  preAlertDetails,
  preAlertPages,
  patchPreAlert,
  dashboardPreAlertPages,
  putPreAlert,
  patchPreAlertError,
  preAlertQuery,
  dashboardPreAlertQuery,
} from '@models/PreAlert';
import * as t from 'io-ts';

export const preAlertApis = createDefaultTyrann({
  '/pre-alert/': {
    get: {
      query: preAlertQuery,
      response: {
        200: preAlertPages,
      },
    },
  },
  '/pre-alert/{d2d_no}/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: preAlertDetails,
        404: t.type({
          detail: t.string,
        }),
      },
    },
  },
  '/dashboard/pre-alert/{d2d_no}/': {
    get: {
      path: t.type({
        d2d_no: t.string,
      }),
      response: {
        200: preAlertDetails,
        404: t.type({
          detail: t.string,
        }),
      },
    },
    patch: {
      path: t.type({
        d2d_no: t.string,
      }),
      body: patchPreAlert,
      response: {
        200: preAlertDetails,
        400: patchPreAlertError,
        500: t.type({
          detail: t.string,
        }),
      },
    },
  },
  '/dashboard/pre-alert/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: preAlertDetails,
        404: t.type({
          detail: t.string,
        }),
      },
    },
    put: {
      path: t.type({
        id: t.number,
      }),
      body: putPreAlert,
      response: {
        200: patchPreAlert,
        500: t.type({
          detail: t.string,
        }),
      },
    },
  },
  '/dashboard/pre-alert/{id}/create/': {
    put: {
      path: t.type({
        id: t.number,
      }),
      body: putPreAlert,
      response: {
        200: preAlertDetails,
        400: t.type({
          message: t.string,
        }),
      },
    },
  },
  '/dashboard/pre-alert/': {
    get: {
      query: dashboardPreAlertQuery,
      response: {
        200: dashboardPreAlertPages,
      },
    },
  },
  '/dashboard/pre-alert/count/': {
    get: {
      query: dashboardPreAlertQuery,
      response: {
        200: t.type({
          count: t.number,
        }),
      },
    },
  },
});
